/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SaleInputs */

const cs_enum_sale = /** @type {(inputs: Enum_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodej`)
};

const en_enum_sale = /** @type {(inputs: Enum_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale`)
};

/**
* | output |
* | --- |
* | "Sale" |
*
* @param {Enum_SaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sale = /** @type {((inputs?: Enum_SaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sale(inputs)
	return cs_enum_sale(inputs)
});